module.exports = __webpack_public_path__ + "static/media/logo-ionic.b69346c0.svg";